module.exports = __webpack_public_path__ + "b41f03446658feab8c4a6a9957da96f5.svg";